import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DatetimePickerComponent implements OnInit {
  @Input() pickerName: string = 'dateTime'; // Name of input
  @Input() pickerType: any = 'both'; // Type of picker. Options: 'both' (date and time), 'calendar' (only date), or 'timer' (only time)
  @Input() selectedDateTime: moment.Moment | null = null; // Selected datetime value (for two-way binding with the parent component)
  @Input() min: moment.Moment | null = null; // The minimum valid date time.
  @Input() max: moment.Moment | null = null; // The maximum valid date time.
  @Input() label: string = 'Date time'; // Label for the picker input field (default is 'Date time')
  @Input() hint: string = ''; // Hint text displayed below the input field to guide the user
  @Input() errorText: string = 'This field is required.'; // Error text displayed below the input field to alert the user that the field is required
  @Input() selectTooltip: string = 'Select Date time.'; // Tooltip text for the select button (shown on hover)
  @Input() removeTooltip: string = 'Remove Date time.'; // Tooltip text for the remove button (shown on hover)
  @Input() isRequired: boolean = false; // Flag to mark the picker as required (true means the picker is required)
  @Input() isDisabled: boolean = false; // Flag to disable the picker input (true means the picker is disabled)
  @Input() classes: string = 'full-width'; // CSS classes to apply to the picker input field (default is 'full-width' to make it span the full width)

  @Input() pickerId: any = 'dt-1'; //  Not being used. Unique identifier for the picker (default is 'dt-1').
  @Input() selectMode: string = 'single'; //  Not being used. Specify the picker's select mode. Options: 'single' (a single value allowed), 'range' (allow users to select a range of date-time), 'rangeFrom' (the input would only show the 'from' value and the picker could only selects 'from' value), 'rangeTo' (the input would only show the 'to' value and the picker could only selects 'to' value)

  @Output() pickerDetailsOutput: EventEmitter<any> = new EventEmitter<any>(); // Emits the selected date/time or changes to the parent component

  constructor() {}

  ngOnInit(): void {}

  /**
   * Handles the event when the date and time are changed.
   * @param {any} event - The event object containing the date and time value.
   * @return {void} - This method does not return any value.
   */
  onDateTimeChanged(event: any) {
    if (event && event.value instanceof moment) {
      this.pickerDetailsOutput.emit(event.value);
    } else {
      this.pickerDetailsOutput.emit(null);
    }
  }

  /**
   * Emits a null value when the date and time are removed.
   * This method resets the value and dateValue to null and emits a null value through pickerDetailsOutput.
   * @return {void}
   */
  onDateTimeRemoved() {
    this.pickerDetailsOutput.emit(null);
  }
}
